goog.provide("shadow.js.shim.module$date_fns$locale$cs$default");
shadow.js.shim.module$date_fns$locale$cs$default = esm_import$date_fns$locale$cs.default;
